export default {
  created () {
    window.addEventListener('message', this.handleParentMessage)
  },
  methods: {
    handleParentMessage (e) {
      // get options
      if (e.data.event && e.data.event === 'set_options') {
        this.setOptions(e.data.value)
      }

      // get context
      if (e.data.event && e.data.event === 'set_context') {
        this.setContext(e.data.value)
      }
    },
    setOptions (value) {
      if (!value || typeof value !== 'object') {
        return false
      }

      Object.keys(value).forEach((k) => {
        const option = this.options[k]

        if (option && typeof value[k] === option.type) {
          this.options[k].value = value[k]
        }
      })

      if (typeof this.setCustomOptions === 'function') {
        this.setCustomOptions()
      }
    },
    setContext (value) {
      if (!value || typeof value !== 'object') {
        return false
      }

      Object.keys(value).forEach((k) => {
        const option = this.context[k]

        if (option && typeof value[k] === option.type) {
          this.context[k].value = value[k]
        }
      })
    }
  }
}